import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../firebase";
import { getDocs, collection, doc, getDoc } from "firebase/firestore";
import {
  Container,
  Main,
  Text,
  Title,
  Unit,
  UnitDescription,
  UnitName,
} from "./studentDrawerKonularim";
import { BsEnvelope, BsEnvelopeExclamation } from "react-icons/bs";
import { Button, CustomLink2 } from "../../../components/buttons/Button.styled";
import Loading from "../../../components/Loading"; // ✅ Loading eklendi

function DrawerSiniflarim() {
  const [user] = useAuthState(auth);
  const belirliKullaniciUID = user ? user.uid : null;
  const [userClasses, setUserClasses] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state eklendi

  const hasUncompletedHomework = async (classUid) => {
    try {
      const userDocRef = doc(db, "users", belirliKullaniciUID);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userHomeworks = userDoc.data().homeworks || [];
        return userHomeworks.some(
          (homework) =>
            homework.classUid === classUid && homework.doneStudent === 0
        );
      } else {
        console.error("Kullanıcı belirtilen UID ile bulunamadı");
        return false;
      }
    } catch (error) {
      console.error("Veri çekme hatası:", error.message);
      return false;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // ✅ Fetch başında loading aç
      try {
        const classRef = collection(db, "classes");
        const classSnapshot = await getDocs(classRef);
        const userClassesData = [];

        for (const classDoc of classSnapshot.docs) {
          const students = classDoc.data().students;
          const matchingStudent = students.find(
            (student) => student.uid === belirliKullaniciUID
          );

          if (matchingStudent) {
            const classData = {
              id: classDoc.id,
              className: classDoc.data().className || "Bilgi Yok",
              teacherUid: classDoc.data().teacherUid || "Bilgi Yok",
            };

            const teacherRef = doc(db, "users", classData.teacherUid);
            const teacherDoc = await getDoc(teacherRef);

            classData.teacherName = teacherDoc.exists()
              ? teacherDoc.data().userData.displayName || "Bilgi Yok"
              : "Bilgi Yok";

            classData.hasUncompletedHomework = await hasUncompletedHomework(
              classData.id
            );
            userClassesData.push(classData);
          }
        }

        setUserClasses(userClassesData);
      } catch (error) {
        console.error("Veri çekme hatası:", error.message);
      } finally {
        setLoading(false); // ✅ İşlem bitince loading kapat
      }
    };

    if (belirliKullaniciUID) fetchData();
  }, [belirliKullaniciUID]);

  if (loading) {
    return <Loading />; // ✅ Loading spinner
  }

  return (
    <Container>
      <Title>
        <Text>Sınıflarım</Text>
      </Title>
      <Main>
        {userClasses.length > 0 ? (
          userClasses.map((userClass) => (
            <Unit key={userClass.id}>
              <UnitName>{userClass.className}</UnitName>
              <UnitDescription style={{ fontSize: "1rem" }}>
                {userClass.teacherName}
                {userClass.hasUncompletedHomework ? (
                  <EnvelopeNotification />
                ) : (
                  <Envelope />
                )}
              </UnitDescription>
              <CustomLink2 to={`/ogrenci-ekrani/sinifim/${userClass.id}`}>
                <Button width={"100%"}> Sınıfa Git</Button>
              </CustomLink2>
            </Unit>
          ))
        ) : (
          <p>Henüz bir sınıfınız bulunmuyor.</p>
        )}
      </Main>
    </Container>
  );
}

const Envelope = styled(BsEnvelope)`
  color: var(--main-color);
  font-size: 30px;
`;

const EnvelopeNotification = styled(BsEnvelopeExclamation)`
  color: var(--main-color);
  font-size: 30px;
`;

export default DrawerSiniflarim;
